import React, { useEffect, useState } from "react"
import { api } from "../../include/api"
import { ADD, EDIT, ERROR, SUCCESS } from "../../include/constant"
import { preventArrow, preventClick, preventWheel, validatePhoneNumber, validatePincode } from "../../include/function"
import { useNotification } from "../../Toast/ToastProvider"

const AddressForm = ({ id, userId, type, reqConfig, title, onSave, editAddress, onCancel, forceAddressType = null, showGstField = false }) => {
  const toast = useNotification()

  const [saving, setSaving] = useState(false)
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberError, setPhoneNumberError] = useState('')
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState('')
  const [alternatePhoneNumberError, setAlternatePhoneNumberError] = useState('')
  const [locality, setLocality] = useState('')
  const [localityError, setLocalityError] = useState('')
  const [address, setAddress] = useState('')
  const [addressError, setAddressError] = useState('')
  const [city, setCity] = useState('')
  const [cityError, setCityError] = useState('')
  const [state, setState] = useState('')
  const [stateError, setStateError] = useState('')
  const [landmark, setLandmark] = useState('')
  const [landmarkError, setLandmarkError] = useState('')
  const [pin, setPin] = useState('')
  const [pinError, setPinError] = useState('')
  const [addressType, setAddressType] = useState('')
  const [addressTypeError, setAddressTypeError] = useState('')
  const [gstNo, setGstNo] = useState("");

  const handleName = (value) => {
    setNameError('')
    setName(value)
  }

  const handlePhoneNumber = (value) => {
    setPhoneNumberError('')
    setPhoneNumber(value)
  }

  const handleAlternatePhoneNumber = (value) => {
    setAlternatePhoneNumberError('')
    setAlternatePhoneNumber(value)
  }

  const handleLocality = (value) => {
    setLocalityError('')
    setLocality(value)
  }

  const handleAddress = (value) => {
    setAddressError('')
    setAddress(value)
  }

  const handleCity = (value) => {
    setCityError('')
    setCity(value)
  }

  const handleState = (value) => {
    setStateError('')
    setState(value)
  }

  const handleLandmark = (value) => {
    setLandmarkError('')
    setLandmark(value)
  }

  const handlePin = (value) => {
    setPinError('')
    setPin(value)
  }

  const handleAddressType = (value) => {
    setAddressTypeError('')
    setAddressType(value)
  }

  const handlePincodeChange = async (e) => {
    setPin(e.target.value);
    if (e.target.value.length === 6) {  // Ensure it's a valid pincode length
      try {
        // Fetch address details based on pincode
        const response = await fetch(`https://api.postalpincode.in/pincode/${e.target.value}`);
        const data = await response.json();

        if (data[0].Status === 'Success') {
          const { PostOffice } = data[0];
          if (PostOffice && PostOffice.length > 0) {
            const { Name, District, State, } = PostOffice[0];
            setLocality(Name);
            setCity(District);
            setState(State);
          }
        }
      } catch (error) {
        console.error('Error fetching address:', error);
      }
    }
    setPinError('Pincode required')
  };

  const handleSave = () => {
    let error = false;
    const finaladdressType = forceAddressType || addressType.trim();
    const data = {
      id: String(id).trim(),
      customerId: String(userId).trim(),
      name: String(name).trim(),
      phoneNumber: String(phoneNumber).trim(),
      locality: String(locality).trim(),
      address: String(address).trim(),
      city: String(city).trim(),
      state: String(state).trim(),
      pin: String(pin).trim(),
      // addressType: String(addressType).trim(),
      addressType: finaladdressType,

      landmark: String(landmark).trim(),
      alternatePhoneNumber: String(alternatePhoneNumber).trim(),
    }

    if (showGstField) {
      data.gstNo = String(gstNo).trim();
    }

    if (data.name === '') {
      setNameError('Name required')
      error = true
    } else if (data.name.length > 100) {
      setNameError('Name is too long')
      error = true
    }

    if (data.phoneNumber === '') {
      setPhoneNumberError('Phone number required')
      error = true
    } else if (!validatePhoneNumber(data.phoneNumber)) {
      setPhoneNumberError('Invalid phone number')
      error = true
    }

    if (data.locality === '') {
      setLocalityError('Locality required')
      error = true
    } else if (data.locality.length > 300) {
      setLocalityError('Locality is too long')
      error = true
    }

    if (data.address === '') {
      setAddressError('Address required')
    } else if (data.address.length > 500) {
      setAddressError('Address is too long')
      error = true
    }

    if (data.city === '') {
      setCityError('City required')
    } else if (data.city.length > 300) {
      setCityError('City is too long')
      error = true
    }

    if (data.landmark !== '' && data.landmark.length > 300) {
      setLandmarkError('Landmark is too long')
      error = true
    }

    if (data.alternatePhoneNumber !== '' && !validatePhoneNumber(data.alternatePhoneNumber)) {
      setAlternatePhoneNumberError('Invalid phone number')
      error = true
    }

    if (data.state === '') {
      setStateError('State required')
      error = true
    }

    if (data.pin === '') {
      setPinError('Pincode required')
      error = true
    } else if (!validatePincode(data.pin)) {
      setPinError('Invalid pincode')
      error = true
    }

    // if (data.addressType === '') {
    //     setAddressTypeError('Address type required')
    //     error = true
    // }

    if (!forceAddressType && data.addressType === "") {
      setAddressTypeError("Address type required");
      error = true;
    }

    if (!error) {
      if (type === ADD) {
        setSaving(true)
        api.post('/customer_address/', data, reqConfig).then(response => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message })
            data.id = response.data.data.id
            onSave(data)
          }
        }).catch(error => {
          error.response ?
            toast({ type: ERROR, message: error.response.data.message }) :
            toast({ type: ERROR, message: error.message })
        }).finally(() => setSaving(false))
      } else if (type === EDIT) {
        setSaving(true)
        api.put('/customer_address/?id=' + id, data, reqConfig).then(response => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message })
            onSave(data)
          }
        }).catch(error => {
          error.response ?
            toast({ type: ERROR, message: error.response.data.message }) :
            toast({ type: ERROR, message: error.message })
        }).finally(() => setSaving(false))
      }
    }
  }

  useEffect(() => {
    if (editAddress) {
      setName(editAddress.name)
      setPhoneNumber(editAddress.phoneNumber)
      setAlternatePhoneNumber(editAddress.alternatePhoneNumber || '')
      setLocality(editAddress.locality || '')
      setAddress(editAddress.address)
      setCity(editAddress.city)
      setState(editAddress.state)
      setLandmark(editAddress.landmark)
      setPin(editAddress.pin)
      setAddressType(editAddress.addressType)
      if (showGstField) {
        setGstNo(editAddress.gstNo || "");
      }
    } else {
      if (showGstField) setGstNo("");

    }
  }, [editAddress])

  return (
    <div className={`py-3 ${type === EDIT ? "border-top" : ""}`}>
      <h5 className="mt-5 text-xl mb-25">{title}</h5>
      <div className="row my-2">
        <div className="col-12 col-md-6">
          <h6
            htmlFor="name"
            className="text-md mb-16 fw-bold "
          >
            Name
          </h6>
          <input
            type="text"
            className={`common-input form-control ${nameError !== "" && "border-danger"
              }`}
            placeholder="Name"
            id="name"
            autoFocus
            required
            autoComplete="off"
            onChange={(e) => handleName(e.target.value)}
            value={name}
          />
          <span className="text-danger my-2 small fw-bold">{nameError}</span>
          <br />
        </div>
        <div className="col-12 col-md-6">
          <h6
            htmlFor="phoneNumber"
            className="text-md mb-16 fw-bold "
          >
            Phone Number
          </h6>
          <input
            type="number"
            className={`common-input form-control ${phoneNumberError !== "" && "border-danger"
              }`}
            placeholder="Phone Number"
            id="phoneNumber"
            required
            autoComplete="off"
            onFocus={(e) => preventWheel(e)}
            onKeyDown={(e) => preventArrow(e)}
            onChange={(e) => handlePhoneNumber(e.target.value)}
            value={phoneNumber}
          />
          <span className="text-danger my-2 small fw-bold">
            {phoneNumberError}
          </span>
          <br />
        </div>
        <div className="col-12">
          <h6
            htmlFor="address"
            className="text-md mb-16 fw-bold "
          >
            Address (Street and Area)
          </h6>
          <textarea
            className={`common-input form-control resize-none w-100 ${addressError !== "" && "border-danger"
              }`}
            rows="5"
            id="address"
            placeholder="Address (Street and Area)"
            autoComplete="off"
            onChange={(e) => handleAddress(e.target.value)}
            value={address}
          />
          <span className="text-danger my-2 small fw-bold">
            {addressError}
          </span>
          <br />
        </div>
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="pincode"
            className="text-md mb-16 fw-bold "
          >
            Pincode
          </h6>
          <input
            type="number"
            className={`common-input form-control ${pinError !== "" && "border-danger"
              }`}
            placeholder="Enter Pincode"
            id="pincode"
            maxLength={6}
            onFocus={(e) => preventWheel(e)}
            onKeyDown={(e) => preventArrow(e)}
            onChange={handlePincodeChange}
            value={pin}
          />
          {/* <span className="text-danger my-2 small fw-bold">{pinError}</span> */}
        </div>

        {/* <div className="col-12 col-md-6 col-xl-4">
                <h6 htmlFor="pin" className="small">Pincode</h6>
                <input type="number" className={`common-input form-control ${pinError !== '' && 'border-danger'}`} placeholder="Pincode" id="pin" required autoComplete="off" onFocus={e => preventWheel(e)} onKeyDown={e => preventArrow(e)} 
                onChange={e => handlePin(e.target.value)} value={pin} />
                <span className="text-danger my-2 small fw-bold">{pinError}</span>
                <br />
            </div> */}
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="locality"
            className="text-md mb-16 fw-bold "
          >
            Locality
          </h6>
          <input
            type="text"
            className={`common-input form-control ${localityError !== "" && "border-danger"
              }`}
            placeholder="Locality"
            id="locality"
            required
            autoComplete="off"
            onChange={(e) => handleLocality(e.target.value)}
            value={locality}
          />
          <span className="text-danger my-2 small fw-bold">
            {localityError}
          </span>
          <br />
        </div>
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="city"
            className="text-md mb-16 fw-bold "
          >
            City/District/Town
          </h6>
          <input
            type="text"
            className={`common-input form-control ${cityError !== "" && "border-danger"
              }`}
            placeholder="City/District/Town"
            id="city"
            required
            autoComplete="off"
            onChange={(e) => handleCity(e.target.value)}
            value={city}
          />
          <span className="text-danger my-2 small fw-bold">{cityError}</span>
          <br />
        </div>
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="state"
            className="text-md mb-16 fw-bold "
          >
            State
          </h6>
          <input
            placeholder="State"
            className={`common-input form-control ${stateError !== "" && "border-danger"
              }`}
            id="state"
            required
            onChange={(e) => handleState(e.target.value)}
            value={state}
          />
          {/* <option value="" disabled>Select State</option> */}
          {/* {stateList.map((state, index) => <option key={nanoid()} value={state}>{state}</option>)} */}
          {/* </select> */}
          <span className="text-danger my-2 small fw-bold">{stateError}</span>
          <br />
        </div>
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="landmark"
            className="text-md mb-16 fw-bold "
          >
            Landmark (Optional)
          </h6>
          <input
            type="text"
            className={`common-input form-control ${landmarkError !== "" && "border-danger"
              }`}
            placeholder="Landmark"
            id="landmark"
            autoComplete="off"
            onChange={(e) => handleLandmark(e.target.value)}
            value={landmark}
          />
          <span className="text-danger my-2 small fw-bold">
            {landmarkError}
          </span>
          <br />
        </div>
        <div className="col-12 col-md-6 col-xl-4">
          <h6
            htmlFor="alternatePhoneNumber"
            className="text-md mb-16 fw-bold "
          >
            Alternate&nbsp;Phone&nbsp;(Optional)
          </h6>
          <input
            type="number"
            className={`common-input form-control ${alternatePhoneNumberError !== "" && "border-danger"
              }`}
            placeholder="Alternate Phone"
            id="alternatePhoneNumber"
            autoComplete="off"
            onFocus={(e) => preventWheel(e)}
            onKeyDown={(e) => preventArrow(e)}
            onChange={(e) => handleAlternatePhoneNumber(e.target.value)}
            value={alternatePhoneNumber}
          />
          <span className="text-danger my-2 small fw-bold">
            {alternatePhoneNumberError}
          </span>
          <br />
        </div>
        {showGstField && (
          <div className="col-12">
            <h6
              htmlFor="gstNo"
              className="text-md mb-16 fw-bold "
            >
              GST Number (Optional)
            </h6>
            <input
              type="text"
              className="common-input form-control"
              placeholder="Enter GST Number"
              id="gstNo"
              value={gstNo}
              onChange={(e) => setGstNo(e.target.value)}
            />
          </div>
        )}
        {/* <div className="col-12 col-xl-8">
            <h6 className="text-md mb-16 fw-bold ">
              Address Type
            </h6>
            <div className="row">
              <div className="col-12 col-sm-6 mb-3">
                <div
                  onClick={() => handleAddressType("home")}
                  className={`common-input form-control d-flex justify-content-between align-items-center cursor-pointer ${
                    addressType === "home"
                      ? "text-dark fw-bold bg-primary-important"
                      : ""
                  }`}
                >
                  <h6 htmlFor="home" className="mb-0">
                    Home
                  </h6>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="addressType"
                    id="home"
                    checked={addressType === "home"}
                    onChange={() => handleAddressType("home")}
                  />
                </div>
              </div>
             

              <div className="col-12 col-sm-6 mb-3">
                <h6
                  htmlFor="work"
                  className={`common-input form-control d-flex justify-content-between align-items-center cursor-pointer ${
                    addressType === "work" ? "text-dark fw-bold" : ""
                  }`}
                >
                  <span>Work</span>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="addressType"
                    id="work"
                    checked={addressType === "work"}
                    onChange={(e) => handleAddressType("work")}
                  />
                </h6>
              </div>
            </div>
            <span className="text-danger my-2 small fw-bold">
              {addressTypeError}
            </span>
            <br />
          </div> */}
        {!forceAddressType && (
          <div className="col-12 col-xl-8">
            <h6 className="text-md mb-16 fw-bold ">
              Address Type
            </h6>
            <div className="row">
              <div className="col-12 col-sm-6 mb-3">
                <div
                  onClick={() => handleAddressType("home")}
                  className={`common-input form-control d-flex justify-content-between align-items-center cursor-pointer ${addressType === "home"
                    ? "text-dark fw-bold bg-primary-important"
                    : ""
                    }`}
                >
                  <span htmlFor="home" className="mb-0">
                    Home
                  </span>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="addressType"
                    id="home"
                    checked={addressType === "home"}
                    onChange={() => handleAddressType("home")}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 mb-3">
                <h6
                  htmlFor="work"
                  className={`common-input form-control d-flex justify-content-between align-items-center cursor-pointer ${addressType === "work" ? "text-dark fw-bold" : ""
                    }`}
                >
                  <span>Work</span>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="addressType"
                    id="work"
                    checked={addressType === "work"}
                    onChange={(e) => handleAddressType("work")}
                  />
                </h6>
              </div>
            </div>
            <span className="text-danger my-2 small fw-bold">
              {addressTypeError}
            </span>
          </div>
        )}
      </div>
      <div className="my-2 w-100 d-flex align-items-center">
        {saving ? (
          <button
            className="btn btn-main me-3"
            onClick={(e) => e.preventDefault()}
          >
            Save
          </button>
        ) : (
          <button
            className="btn btn-main me-3"
            onClick={(e) => preventClick(e, handleSave)}
          >
            Save
          </button>
        )}
        <button
          className="btn btn-main me-3"
          onClick={(e) => preventClick(e, onCancel)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
export default AddressForm